export default __webpack_public_path__ + "static/media/contactus-banner.25f8e5db.jpg";